module.exports = __webpack_public_path__ + "img/aniket.c5ba80de.jpg";